<template lang="pug">
  div
    transition(name="fade")
      .bg-black-op-p075.px-4.py-3(v-if="!isOriginalEqClone")
        .row.align-items-center
          .col-auto
            el-button(
              type="text"
              icon="el-icon-arrow-left"
              @click="$router.push('/')"
            ).text-secondary Back
          .col-auto.ml-auto
            el-button(type="primary" @click="validateForm('form')" v-loading="isSaving") Save

    .p-30
      .container.px-0
        .fs-18.text-uppercase.mb-4 Personal Info

        .card
          .card-body.p-md-4.p-lg-5
            el-form(
              ref="form"
              status-icon
              label-position="top"
              :model="profile"
              :rules="rules"
            )
              .row
                .col-md-auto.mb-4(v-if="isImageUpload")
                  .size-150.mx-auto.mx-md-0
                    avatar-uploader(
                      :imageUrl="profile.imageUrl"
                      @fileSelected="handleFileSelect($event)",
                    )

                .col
                  .row
                    .col-sm-6
                      el-form-item(prop="firstName" label="First Name")
                        el-input(v-model="profile.firstName")
                    .col-sm-6
                      el-form-item(prop="lastName" label="Last Name")
                        el-input(v-model="profile.lastName")
                    .col-sm-6
                      el-form-item(prop="email" label="Email")
                        el-input(v-model="profile.email" type="email")
                    .col-sm-6
                      el-form-item(prop="phone" label="Phone")
                        el-input(
                          v-model="profile.phone"
                          v-mask="'(###) ###-####'"
                          type="tel" placeholder="(123) 456-7890"
                        )

                    template(v-if="showChangePassInput")
                      .col-sm-6
                        el-form-item(prop="oldPassword" label="Old Password")
                          el-input(v-model="profile.oldPassword", type="password")
                      .col-sm-6
                        el-form-item(prop="password" label="New Password")
                          el-input(v-model="profile.password" type="password")
                      .col-sm-6.mt-4
                        el-form-item
                          el-button(
                            type="primary"
                            @click="updatePassword"
                          ).w-100 Submit

                    .col-sm-6.mt-4(v-if="!showChangePassInput")
                      el-form-item
                        el-button(
                          type="primary"
                          @click="showChangePassInput = true"
                        ).w-100 Change Password
</template>

<script>
import { mask } from 'vue-the-mask';
import AvatarUploader from '@/components/AvatarUploader.vue';
import { mapGetters } from 'vuex';

// import CrudDialogMixin from '@/mixins/crudDialogMixin';
// import SubscribeMixin from '@/mixins/subscribeMixin';
import {
  updateUserRecord,
  cognitoChangePassword,
} from '../models/user';

export default {
  name: 'Profile',
  directives: { mask },
  components: { AvatarUploader },

  data() {
    return {
      isSaving: false,
      errorMessage: '',
      profileClone: {},
      isImageUpload: false,
      isOriginalEqClone: true,
      showChangePassInput: false,
      selectedFile: null,
      profile: this.initProfile(),
      rules: {
        email: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
        ],

        phone: [
          { required: true, message: 'Phone Number is required', trigger: 'blur' },

          // Min 14 length bcoz that includes brackets and space and hyphen. eg. (###) ###-####
          { min: 14, message: 'Length should be 10 digits', trigger: 'blur' },
        ],

        firstName: {
          required: true, pattern: /^[a-zA-Z ]{2,25}$/, message: 'First Name is required', trigger: 'blur',
        },

        lastName: {
          required: true, pattern: /^[a-zA-Z ]{2,25}$/, message: 'Last Name is required', trigger: 'blur',
        },
      },
    };
  },

  computed: {
    ...mapGetters('users', ['me', 'isMeSignedIn', 'company']),
  },

  watch: {
    me(val) {
      if (val) {
        this.init();
      }
    },
  },

  mounted() {
    this.profileClone = { ...this.profile };
    this.init();
  },

  methods: {
    init() {
      if (this.me) {
        console.log(this.me);
        const { userRecord } = this.me;
        if (userRecord) {
          this.profile.firstName = userRecord.firstName;
          this.profile.lastName = userRecord.lastName;
          this.profile.email = userRecord.email;
          this.profile.phone = userRecord.phone;
        }
      }
    },
    initProfile() {
      console.log('....init profile ....');
      return {
        firstName: '',
        lastName: '',
        imageUrl: '',
        email: '',
        phone: '',
      };
    },
    handleSave() {
      this.isSaving = true;

      setTimeout(() => {
        // shallow clone new data
        this.profileClone = { ...this.profile };
        this.isOriginalEqClone = true;
        this.isSaving = false;
      }, 2000);
    },
    async updatePassword() {
      if (this.showChangePassInput) {
        this.loading = false;
        try {
          console.log(this.me);
          const cogUser = await cognitoChangePassword(this.me,
            this.profile.oldPassword,
            this.profile.password);
          this.$notify({
            message: 'Password Updated Successfully',
            type: 'success',
          });
          console.log(cogUser);
        } catch (err) {
          this.$notify({
            message: err.message,
            type: 'danger',
          });
          console.log('something went wrong while Changing Password');
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
      return false;
    },
    async updateUser() {
      console.log('trying updating user');
      this.loading = true;
      try {
        const userRecord = await updateUserRecord(this.editedItem);
        console.log(userRecord);
      } catch (err) {
        console.log('something went wrong while updating');
        console.log(err);
      } finally {
        this.closeDialog();
        this.loading = false;
      }
    },
    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) return this.handleSave();
        console.log('error submit!!');
        return false;
      });
    },

    handleFileSelect({ selectedFile, image }) {
      this.selectedFile = selectedFile;
      this.profile.imageUrl = image;
    },
  },
};
</script>
